// @ts-expect-error not migrated to TS yet

// @ts-expect-error not migrated to TS yet
import EmailUnarchiveMultiModal from 'email-management-lib/refactor/components/manage/modals/multi/EmailUnarchiveMultiModal';
import { DETAIL_ACTIONS } from 'EmailComponents/utils/actions/detailActionsUtil';
import ArchiveModal from 'email-management-lib/EmailArchiveOrDelete/components/ArchiveModal';
import DeleteModal from 'email-management-lib/EmailArchiveOrDelete/components/DeleteModal';
import MoveToFolderMultiModal from 'email-management-lib/refactor/components/shared/MoveToFolderMultiModal';
import listingLibObserver from 'framework-listing-lib/utils/listingLibObserver';
import { Component } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
class BulkActions extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      showDeleteModal: false,
      showArchiveModal: false,
      showMoveToFolderModal: false
    };
  }
  deleteModalHandler(actionHandler) {
    return event => {
      actionHandler(event);
      this.props.onModalClose();
    };
  }
  archiveModalHandler(actionHandler) {
    return event => {
      actionHandler(event);
      this.props.onModalClose();
    };
  }
  moveToFolderModalHandler(actionHandler) {
    return (event, folderId, folderName) => {
      if (actionHandler) {
        actionHandler(event, folderId, folderName);
      }
      this.props.onModalClose();
    };
  }
  renderDeleteModal() {
    const {
      selected,
      onModalClose,
      isFramework
    } = this.props;
    return /*#__PURE__*/_jsx(DeleteModal, {
      emails: selected.toArray(),
      onClose: onModalClose,
      listingLibObserver: isFramework ? listingLibObserver : undefined
    });
  }
  renderMoveToFolderModal() {
    const {
      onMoveToFolder,
      onModalClose,
      selected
    } = this.props;
    return /*#__PURE__*/_jsx(MoveToFolderMultiModal, {
      onCancel: onModalClose,
      onMoveToFolder: this.moveToFolderModalHandler(onMoveToFolder),
      toMoveElements: selected.valueSeq().toArray()
    });
  }
  renderArchiveModal() {
    const {
      selected,
      onModalClose,
      isFramework
    } = this.props;
    return /*#__PURE__*/_jsx(ArchiveModal, {
      listingLibObserver: isFramework ? listingLibObserver : undefined,
      emails: selected.toArray(),
      onClose: onModalClose
    });
  }
  renderUnarchiveModal() {
    const {
      selected,
      onUnarchive,
      onModalClose
    } = this.props;
    return /*#__PURE__*/_jsx(EmailUnarchiveMultiModal, {
      onCancel: onModalClose,
      onUnarchive: this.archiveModalHandler(onUnarchive),
      selected: selected
    });
  }
  render() {
    switch (this.props.currentModal) {
      case DETAIL_ACTIONS.DELETE:
        return this.renderDeleteModal();
      case DETAIL_ACTIONS.ARCHIVE:
        return this.renderArchiveModal();
      case DETAIL_ACTIONS.MOVE_TO_FOLDER:
        return this.renderMoveToFolderModal();
      case DETAIL_ACTIONS.UNARCHIVE:
        return this.renderUnarchiveModal();
      default:
        return null;
    }
  }
}
export default BulkActions;